export interface Tomo {
  id: string;
  tab: string;
  kicker: string;
  title: string;
  description: string;
}
export interface Bono {
  number: string;
  title: string;
  description: string;
  price: string;
  image?: string;
  imageSize?: 'full' | 'half';
}
export interface Testimonial {
  quote: string;
  name: string;
  city: string;
  initials: string;
}
export interface Faq {
  question: string;
  answer: string;
}
export interface ComparisonRow {
  situation: string;
  without: string;
  with: string;
}
export const painPoints: string[] = ['Un técnico te soltó números que no entendiste y te fuiste igual de perdido que antes', 'Otro te ofreció un sistema que "se paga solo en 3 años" sin enseñarte un solo cálculo', 'En internet solo encuentras información en inglés, desactualizada o de otros mercados', 'Subvenciones e incentivos que existen en tu país pero nadie te explicó cómo reclamarlos', 'El miedo real: gastar miles y que el sistema no produzca lo prometido', 'Y mientras tanto, sigues pagando la misma factura de siempre, mes tras mes'];
export const letterParagraphs: string[] = ['El problema no es que los instaladores sean malos.', 'Es que TÚ no tienes forma de VERIFICAR su trabajo. Dependes 100% de lo que te digan.', 'No tienes criterio técnico.', 'No tienes checklist.', 'No tienes forma de evaluar.', 'Eso te pone en desventaja total.'];
export const solutionPoints: string[] = ['Detectar estafas antes de firmar', 'Conocer los incentivos y beneficios legales de su país', 'Calcular su ahorro y ROI real con números propios', 'Supervisar su instalación con criterio profesional'];
export const benefits: string[] = ['Calcula exactamente cuántos paneles necesita TU casa, sin depender de lo que te diga el instalador', 'Audita cualquier presupuesto solar en menos de 5 minutos y detecta cobros abusivos antes de firmar', 'Conoce los incentivos, subvenciones y beneficios fiscales disponibles en tu país que casi nadie reclama', 'Supervisa tu instalación con diagramas visuales reales, no con manuales técnicos imposibles de entender', 'Calcula tu ROI exacto y descubre en cuántos meses recuperas tu inversión con números reales', 'Negocia con instaladores desde una posición de poder, no desde la ignorancia que ellos aprovechan', 'Registra tu producción y ahorro mes a mes para convertir tu sistema solar en un activo financiero medible', 'Evita los 27 errores más comunes del mercado solar en España y Latinoamérica que cuestan miles a las familias'];
export const tomos: Tomo[] = [{
  id: 'tomo-1',
  tab: 'Tomo 1',
  kicker: 'Tomo 1 · Fundamentos',
  title: 'Ciencia del Ahorro y Dimensionamiento',
  description: 'Cómo leer tu factura, calcular tu consumo real y dimensionar el sistema exacto que necesitas. Sin gastar de más, sin quedarte corto.'
}, {
  id: 'tomo-2',
  tab: 'Tomo 2',
  kicker: 'Tomo 2 · Hardware',
  title: 'Hardware Solar Inteligente',
  description: 'Paneles, inversores, baterías y controladores. Qué comprar, qué evitar, y cómo detectar componentes de segunda que te venden como premium.'
}, {
  id: 'tomo-3',
  tab: 'Tomo 3',
  kicker: 'Tomo 3 · Instalación',
  title: 'Instalación Física Paso a Paso',
  description: 'Montaje en tejado, orientación de paneles, cableado DC y conexiones seguras. Con fotos reales de "Instalación Correcta vs. Instalación Peligrosa".'
}, {
  id: 'tomo-4',
  tab: 'Tomo 4',
  kicker: 'Tomo 4 · Red y Legalización',
  title: 'Conexiones AC, Red y Compensación de Excedentes',
  description: 'Cómo conectarte a la red, verter tu excedente, tramitar la compensación o el net metering de tu país y cobrar por la energía que produces. Legal y documentado.'
}, {
  id: 'tomo-5',
  tab: 'Tomo 5',
  kicker: 'Tomo 5 · Operación',
  title: 'Mantenimiento, Diagnóstico y Escalabilidad',
  description: 'Cómo mantener tu sistema en máximo rendimiento, detectar fallos antes de que cuesten caro y cuándo y cómo ampliar tu instalación.'
}];
export const tomoIncludes: string[] = ['Guías visuales con diagramas reales', 'Checklists de verificación por etapa', 'Alertas de errores comunes y estafas', 'Calculadoras y tablas de referencia', 'Formularios y plantillas legales', 'Adaptado a España y Latinoamérica', 'Lenguaje claro, sin jerga técnica', '100% PDF descargable e imprimible'];
export const bonos: Bono[] = [{
  number: '01',
  title: 'Calculadora Solar Express 360°',
  description: 'Calcula tu sistema ideal en menos de 10 minutos. Sin fórmulas complejas: solo completa los datos de tu factura y el sistema hace el resto.',
  price: '$19 USD',
  image: 'https://cdn.magicpatterns.com/uploads/2LsaGiTiv3aYygC4Lt3aWx/Bono-1.png',
  imageSize: 'half'
}, {
  number: '02',
  title: 'Kit Anti-Estafa Solar',
  description: 'Las 27 trampas más comunes del mercado solar y cómo detectarlas antes de firmar. Audita cualquier presupuesto en menos de 5 minutos.',
  price: '$17 USD',
  image: 'https://cdn.magicpatterns.com/uploads/2Na68g725ib3SqZmi8BoG9/Bono-2.png',
  imageSize: 'half'
}, {
  number: '03',
  title: 'Checklist Fotográfico de Tejado',
  description: 'Evalúa si tu tejado es apto para paneles solares con fotos y criterios visuales. Detecta problemas estructurales antes de la instalación.',
  price: '$17 USD',
  image: 'https://cdn.magicpatterns.com/uploads/vzqTZPmSE5qU71Wi3SoujL/Bono-3.png',
  imageSize: 'half'
}, {
  number: '04',
  title: 'Plan de Ahorro Solar en 7 Días',
  description: 'Un plan de acción diario para pasar de cero conocimiento a tener tu proyecto solar completamente definido y listo para ejecutar en una semana.',
  price: '$17 USD',
  image: 'https://cdn.magicpatterns.com/uploads/3N1FBHn84PMkr2CrsPiR6w/Bono-4.png',
  imageSize: 'half'
}, {
  number: '05',
  title: 'Bitácora Solar Pro',
  description: 'El registro anual de producción, ahorro, mantenimiento y ROI real que convierte tu instalación en un activo financiero medible y documentado.',
  price: '$19 USD',
  image: 'https://cdn.magicpatterns.com/uploads/em3yvVJ12595NcB9t2Xomn/Bono-5.png',
  imageSize: 'half'
}];
export const heroTestimonials: Testimonial[] = [{
  quote: 'Calculé mi ROI en una tarde. El instalador me quería vender el doble de paneles. El Tomo 2 me salvó miles de dólares.',
  name: 'Carlos R.',
  city: 'Madrid, España',
  initials: 'CR'
}, {
  quote: 'Los diagramas de instalación son clarísimos. Lo seguí paso a paso y ahora produzco más de lo que consumo.',
  name: 'María L.',
  city: 'Ciudad de México, México',
  initials: 'ML'
}, {
  quote: 'El bono de la Calculadora Express me ahorró contratar a un consultor. Todo está en el pack. Vale cada peso.',
  name: 'Jorge P.',
  city: 'Bogotá, Colombia',
  initials: 'JP'
}];
export const testimonials: Testimonial[] = [{
  quote: 'El Kit Anti-Estafa me salvó de un instalador que me quería cobrar el doble por paneles de marca desconocida. Recuperé el precio del manual en el primer presupuesto.',
  name: 'Andrés M.',
  city: 'Santiago de Chile',
  initials: 'AM'
}, {
  quote: 'Por fin entendí mi factura de luz. En una tarde dimensioné mi sistema y en dos semanas ya tenía tres presupuestos que podía comparar con criterio real.',
  name: 'Sofía R.',
  city: 'Valencia, España',
  initials: 'SR'
}, {
  quote: 'La Bitácora Solar Pro es lo mejor. Llevo 8 meses registrando producción y ahorro. Ya sé exactamente cuándo recupero la inversión. Eso no te lo da ningún instalador.',
  name: 'Fernando G.',
  city: 'Lima, Perú',
  initials: 'FG'
}, {
  quote: 'El Tomo 4 sobre compensación de excedentes me ayudó a cobrarle a la distribuidora por primera vez. Nadie me había explicado el trámite de forma tan clara.',
  name: 'Laura C.',
  city: 'Medellín, Colombia',
  initials: 'LC'
}];
export const comparisonRows: ComparisonRow[] = [{
  situation: 'Evaluar presupuesto de instalador',
  without: 'Firma a ciegas',
  with: 'Auditoría en 5 min'
}, {
  situation: 'Calcular cuántos paneles necesito',
  without: 'Dependes del instalador',
  with: 'Lo calculas tú mismo'
}, {
  situation: 'Detectar estafas en hardware',
  without: 'Sin criterio propio',
  with: 'Kit Anti-Estafa incluido'
}, {
  situation: 'Tramitar subvenciones y compensación de excedentes',
  without: 'Nadie te lo explica',
  with: 'Formularios y guía local'
}, {
  situation: 'Supervisar la instalación física',
  without: 'Confías sin verificar',
  with: 'Diagramas y checklist'
}, {
  situation: 'Medir ROI y ahorro real',
  without: 'Suposiciones del instalador',
  with: 'Bitácora Solar Pro'
}];
export const faqs: Faq[] = [{
  question: '¿Necesito conocimientos técnicos para entenderlo?',
  answer: 'No. El Código Solar 360° fue diseñado específicamente para dueños de casa sin formación técnica. Cada concepto se explica con lenguaje simple, diagramas visuales y ejemplos prácticos. Si sabes leer una factura de luz, puedes seguir todo el sistema.'
}, {
  question: '¿Cómo recibo el material después de comprar?',
  answer: 'Recibirás un email con el enlace de descarga inmediato. En menos de 5 minutos tendrás acceso a todos los tomos y bonos en formato PDF. Funciona en computadora, tablet y celular.'
}, {
  question: '¿Sirve para mi país específico?',
  answer: 'Sí. El sistema base funciona para cualquier instalación solar y el contenido está orientado a España y Latinoamérica: España, México, Colombia, Argentina, Perú, Chile y el resto de la región. Incluye cómo identificar la normativa vigente, las subvenciones e incentivos y los trámites de conexión a red donde vivas.'
}, {
  question: '¿Qué lo diferencia de buscar en YouTube o Google?',
  answer: 'El 95% del contenido gratuito está en inglés, desactualizado o diseñado para mercados diferentes al tuyo. El Código Solar 360° es un sistema secuencial en español, con información verificada, adaptada a tu país y organizada para que puedas tomar decisiones reales de inversión sin depender de nadie.'
}, {
  question: '¿La garantía es real?',
  answer: '100% real. Si en 7 días no estás satisfecho por cualquier motivo, te devolvemos el dinero completo. Sin preguntas, sin formularios. Nuestra tasa de devoluciones es menor al 1% porque el producto cumple lo que promete.'
}];
export const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/ajesGUUrUmXvP7tAhkYykG/hf_20260829_215223_aaafc1b8-79de-407f-9518-828c8ee8d1bc_(1).png';